import application_settings from "../applicationSettings";
import Event from "./Event";

class GetPaymentMethods extends Event {
  eventName = "oms_getGetPaymentMethods";

  constructor() {
    super();
    this.add();
  }

  /**
   * @override
   *
   * Event Function for Get Additional Charges
   *
   * @return void
   *
   */


  eventFunction(data) {
    let clientId = data.client_id;
    let email = (data.email) ? data.email : null;
    let thisObj = this;
    let requestId = data.request_id ? data.request_id : "";
    let action = data.action ? data.action : "";

    // request data
    data.endPoint = application_settings.endPoints.paymentMethods;
    data.data = {
        client_id: clientId,
        email: email
    };

    this.sendRequest(data, function (response) {
        if (response) {
            //format response data
            let data = thisObj.formatResponseData(response);

            //fire success event
            thisObj.onSuccessEvent(data, {
              action: action,
              request_id: requestId,
            });
        }
    });

  }
}

export default GetPaymentMethods;
